__turbopack_context__.v({
  "activeThumbnail": "styles-module__XbHXlq__activeThumbnail",
  "fullscreenButton": "styles-module__XbHXlq__fullscreenButton",
  "galleryContainer": "styles-module__XbHXlq__galleryContainer",
  "mainImage": "styles-module__XbHXlq__mainImage",
  "mainImageContainer": "styles-module__XbHXlq__mainImageContainer",
  "nextButton": "styles-module__XbHXlq__nextButton",
  "prevButton": "styles-module__XbHXlq__prevButton",
  "thumbnailImage": "styles-module__XbHXlq__thumbnailImage",
  "thumbnailWrapper": "styles-module__XbHXlq__thumbnailWrapper",
  "thumbnailsContainer": "styles-module__XbHXlq__thumbnailsContainer",
});
